export function setupPasswordToggles() {
  document.querySelectorAll('.auth-password-toggle').forEach(button => {
    button.onclick = () => {
      const input = button.parentElement?.querySelector('input');
      if (!input) return;

      const isVisible = input.type === 'text';
      input.type = isVisible ? 'password' : 'text';
      button.classList.toggle('is-visible', !isVisible);
      button.setAttribute('aria-label', isVisible ? 'Show password' : 'Hide password');
      button.setAttribute('aria-pressed', String(!isVisible));
      input.focus();
    };
  });
}
